import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  EmployeeResponse,
  Form10AInformation,
  PackagingResponse,
} from "app/api/models";
import {
  CalibrationService,
  EmployeeService,
  Form10AService,
  PackagingService,
} from "app/api/services";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxPrintModule } from "ngx-print";

@Component({
  selector: "app-form10a-step5-dialog",
  templateUrl: "./form10a-step5-dialog.component.html",
  styleUrls: ["./../../../form10a/form10a.component.scss", "./../../../../_styles/calibration-overrides.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FlexLayoutModule,
    DragScrollModule,
    NgxPrintModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
  ]
})
export class Form10aStep5DialogComponent implements OnInit {
  public model: Form10AInformation;
  public fifthFormGroup: FormGroup;

  packagingList: PackagingResponse[];

  public currentUser: EmployeeResponse;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private snack: MatSnackBar,
    public dialogRef: MatDialogRef<Form10aStep5DialogComponent>,
    public calibrationService: CalibrationService,
    private packagingService: PackagingService,
    private formService: Form10AService,
    private employeeService: EmployeeService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (!this.data?.loadcellId) {
      this.close();
      return;
    }

    this.model = {
      labourCostSetting: {},
      formParts: [],
      formExaminationFaults: [],
      formRectificationWork: [],
      roTEItems: [],
      formCustomer: {},
    };
    this.buildForm();

    this.packagingService
      .apiPackagingPackagingsGet$Json({ archived: false })
      .subscribe((res) => {
        this.packagingList = res.data;
      });

    this.employeeService.apiEmployeeEmployeeGet$Json().subscribe((res) => {
      if (!res) return;

      this.currentUser = res.data;

      var loadcellId = parseInt(this.data.loadcellId);

      if (loadcellId) {
        this.formService
          .apiForm10AForm10ALoadcellGet$Json({ loadcellId: loadcellId })
          .subscribe((res) => {
            if (!res) return;
            this.model = res.data;
            this.setFormGroupValues();
          });
      }

      this.cdr.detectChanges();
    });
  }

  buildForm() {
    this.fifthFormGroup = this.fb.group({
      calibrated: [false],
      repairsComplete: [false],
      pressureTest: [false],
      weight: [""],
      dimensions: [""],
      additionalPackagingInfo: [""],
    });
  }

  setFormGroupValues() {
    this.fifthFormGroup.setValue({
      calibrated: this.model.calibrated,
      repairsComplete: this.model.repairsComplete,
      pressureTest: this.model.pressureTest,
      weight: this.model.weight,
      dimensions: this.model.dimensions,
      additionalPackagingInfo: [this.model.additionalPackagingInfo],
    });
  }

  save(doPressureTest: boolean = false) {
    if (this.model.form10aId != null) {
      this.formService
        .apiForm10AEditForm10APost$Json({ body: this.model })
        .subscribe((res) => {
          this.close({pressureTest: doPressureTest});
        });
    } else {
      // apply signature and save new
      this.model.nameOfThePersonAuthenticating =
        this.currentUser.firstName + " " + this.currentUser.lastName;
      this.model.signature = this.currentUser.signature;

      this.formService
        .apiForm10ANewJobPost$Json({ body: this.model })
        .subscribe((res) => {
          if (!res?.data) {
            this.snack.open("There was an error creating new Loadcell", "OK", {
              duration: 4000,
            });

            return;
          }

          this.close({pressureTest: doPressureTest});
        });
    }
  }

  close(data: {pressureTest: boolean} = null) {
    this.dialogRef.close(data);
  }

  updateCalibrated() {
    this.model.calibrated = this.fifthFormGroup.get("calibrated").value;
  }

  updateRepairsComplete() {
    this.model.repairsComplete =
      this.fifthFormGroup.get("repairsComplete").value;
  }

  updatePressureTest() {
    this.model.pressureTest = this.fifthFormGroup.get("pressureTest").value;
  }

  updatePackaging($event: any) {
    this.model.packaging = this.packagingList.find((x) => x.id == $event.value);
  }

  updateWeight() {
    this.model.weight = this.fifthFormGroup.get("weight").value;
  }

  updateDimensions() {
    this.model.dimensions = this.fifthFormGroup.get("dimensions").value;
  }

  updateAdditionalPackagingInfo() {
    this.model.additionalPackagingInfo = this.fifthFormGroup.get(
      "additionalPackagingInfo"
    ).value;
  }
}
